/**
 * careerUtils — ★ Fase 33: helper condivisi Dashboard Carriera ES.
 * Valuta: USD (nominale) per il tenant ES.
 */
import { Target, Zap, Crown } from 'lucide-react';

export const fmtUSD = (v) =>
  `$${Number(v || 0).toLocaleString('es-ES', { maximumFractionDigits: 0 })}`;

export const LEVEL_META = {
  setter: {
    icon: Target,
    badge: 'bg-sky-100 text-sky-800 border-sky-200',
    bar: '[&>div]:bg-sky-500',
  },
  junior: {
    icon: Zap,
    badge: 'bg-amber-100 text-amber-800 border-amber-200',
    bar: '[&>div]:bg-amber-500',
  },
  senior: {
    icon: Crown,
    badge: 'bg-emerald-100 text-emerald-800 border-emerald-200',
    bar: '[&>div]:bg-emerald-600',
  },
};

export function monthLabel(lang, year, month) {
  try {
    const d = new Date(Date.UTC(year, month - 1, 1));
    const s = d.toLocaleDateString(lang || 'es', { month: 'long', year: 'numeric', timeZone: 'UTC' });
    return s.charAt(0).toUpperCase() + s.slice(1);
  } catch {
    return `${month}/${year}`;
  }
}

/** Streak dots — pallini progresso mesi consecutivi (stile gioco). */
export function StreakDots({ value = 0, total = 3, testId }) {
  return (
    <span className="inline-flex items-center gap-1" data-testid={testId}>
      {Array.from({ length: total }).map((_, i) => (
        <span
          key={i}
          className={`w-2.5 h-2.5 rounded-full border ${
            i < value
              ? 'bg-emerald-500 border-emerald-600'
              : 'bg-muted border-border'
          }`}
        />
      ))}
    </span>
  );
}
